(function () {
	'use strict';

	a3_cabin_reports.controller('SyncPaxCtrl', SyncPaxCtrl);
    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name SyncPaxCtrl
    * @description 
    *   Get the latest  PAX and gate Information
    * @ngInject
    */
	function SyncPaxCtrl($scope, InfoAPIService, $uibModalInstance, $route, flightId, LogService, FlightFactory, FlightSessionFactory, CourseFactory, CrewCallFactory, PreviousDutyFactory) {

		var flight = FlightFactory.getFlightFromTotalFlights(flightId);

		$scope.hideElements = true;
		$scope.showOnSuccess = false;
		$scope.showOnEmptyData = false;
		$scope.showOnSuccessNoFlightData = false;
		$scope.showOnOutOfDateRange = false;
		$scope.cancel = cancel;
		$scope.flightId = flightId;

		$scope.isFetchingFlightData = false;
		$scope.flightDataStatus = [
			{
				datatype: "Flight Status",
				status: "PENDING",
				text: "Pending..."
			},
			{
				datatype: "Aircraft Movement",
				status: "PENDING",
				text: "Pending..."
			},
			{
				datatype: "Crew Info",
				status: "PENDING",
				text: "Pending..."
			},
			{
                datatype: "Crew Contacts",
                status: "PENDING",
                text: "Pending..."
            },
			// {
			// 	datatype: "Aims Crew Memos",
			// 	status: "PENDING",
			// 	text: "Pending..."
			// },
			{
				datatype: "Pax Info",
				status: "PENDING",
				text: "Pending..."
			},
			{
				datatype: "Meals",
				status: "PENDING",
				text: "Pending..."
			},
			{
				datatype: "Connections",
				status: "PENDING",
				text: "Pending..."
			},
			{
				datatype: "Campaigns",
				status: "PENDING",
				text: "Pending..."
			},
			{
				datatype: "Luggage Info",
				status: "PENDING",
				text: "Pending..."
			},
			{
				datatype: "Training Info",
				status: "PENDING",
				text: "Pending..."
			}
		];


		$uibModalInstance.closed.then(function () {
			$route.reload();
		});

		var isThisFlightSynced = false;


        /**
         * Close the modal
         * @memberof SyncPaxCtrl
         */
		function cancel() {
			$uibModalInstance.close('close');
		};

		var q = InfoAPIService.getPax(flightId);
		$scope.isFetchingFlightData = true;

		q.then(function (responseData) {
			updateStatusGenerator(responseData);
			$scope.isFetchingFlightData = !($scope.isFetchingFlightData);


			if (responseData == undefined || responseData.data == undefined || responseData.data.data == undefined) {
				var err = new Error();
				err.status = -1;
				var msg = "ResponseData error in sync :" + JSON.stringify(responseData);
				LogService.debug(msg, err)
				q.reject(err);
			}

			//Save training
			var trainingCourses = responseData.data.data.TrainingCourses;
			if(trainingCourses && trainingCourses.length){
				trainingCourses.forEach(function(trainingCourse){
					CourseFactory.upsertCourse(trainingCourse, function(course) {
						FlightSessionFactory.applyTraineeInfoToSession(course, course.Id, new moment(flight.DutyDate).format("YYYY-MM-DD"), flight.DutyNo, flight.DutyDay, function(session) {
						});
					});
				});
			}


			//1. First remove all additional info (phone numbers & previous duties) for this flight
			CrewCallFactory.cleanFlightCrewNumbers(flightId);
            PreviousDutyFactory.cleanFlightPreviousDuties(flightId);


			//2. Then save any fetched info
			if( responseData.data.data.FlightInfo){

				var crew = responseData.data.data.FlightInfo.crew;
				CrewCallFactory.saveFlightPhoneNumbers(flightId, crew, flight.ScheduledArrival, flight.ScheduledDeparture);
                PreviousDutyFactory.saveFlightPreviousDuties(flightId, crew);
			}

			//Save pax
			if (responseData.data.data.CabinServiceManagementLists) {
				for (var i = 0; i < responseData.data.data.CabinServiceManagementLists.length; i++) {

					if (responseData.data.data.CabinServiceManagementLists[i].FlightId == flightId) {
						//check for out of date range pax info
						var today = new Date().getTime();
						var paxDate = new Date(responseData.data.data.CabinServiceManagementLists[i].LastRun).getTime();
						if (paxDate <= today - 172800000) {
							$scope.showOnOutOfDateRange = true;
							break;
						}

						$scope.pax = responseData.data.data.CabinServiceManagementLists[i];
						$scope.showOnSuccess = true;
						isThisFlightSynced = true;
						break;
					}
				}

				if (!$scope.showOnSuccess) {
					$scope.showOnSuccessNoFlightData = true;
				}

				// $timeout(function () {
				// 	$uibModalInstance.close();
				// 	$route.reload();
				// }, 3000);
			}
			else {
				$scope.showOnEmptyData = true;
			}
		},
			function (responseData) {
				updateStatusGenerator(responseData);
				$scope.isFetchingFlightData = !($scope.isFetchingFlightData);
				$scope.hideElements = false;
			});


		function updateStatusGenerator(data) {
			if (!data.data || !data.data.success) {
				for (var i = 0; i < $scope.flightDataStatus.length; i++) {
					$scope.flightDataStatus[i].status = "FAIL";
					$scope.flightDataStatus[i].text = "Update failed";
				}
			} else {
				if (!data.data.data.Campaigns.GetAssignmentsSuccess) {
					$scope.flightDataStatus[6].status = "FAIL";
					$scope.flightDataStatus[6].text = "Update failed";
				}

				var newDuty = data.data.data;
				InfoAPIService.updateFlightStatusSetter(newDuty, $scope.flightDataStatus);
			}
		}
	}

})();